import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiClient } from "src/api/client";
import { Industry } from "src/api/types";

interface IndustryState {
  items: Industry[],
  loading: boolean,
  loaded: boolean,
  error: null | string
}

const initialState: IndustryState = {
  items: [],
  loading: false,
  loaded: false,
  error: null
}

export const fetchIndustries = createAsyncThunk('industries/fetchIndustries', 
  async (_, {rejectWithValue}) => {
    try {
      return await apiClient.getIndustries();
    }
    catch (error) {
      if (error instanceof Error) {
        return rejectWithValue(error.message);
      }

      return rejectWithValue('Unknown type of error occurred');
    }
  }
)

const industrySlice = createSlice({
  name: 'industries',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
    .addCase(fetchIndustries.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchIndustries.fulfilled, (state, action) => {
      state.loading = false;
      state.loaded = true;
      state.items = action.payload;
    })
    .addCase(fetchIndustries.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    })
  }
})

export default industrySlice.reducer;